<template>
  <div class="row">
    <div class="col-12 col-md-6">
      <div class="form-group kt-form__group">
        <label>Episode Type</label>
        <div class="kt-radio-inline">
          <label class="kt-radio">
            <input v-model="episode_details.type" type="radio"
                   name="full"
                   value="full"> Full
            <span />
          </label>
          <label class="kt-radio">
            <input v-model="episode_details.type" type="radio"
                   name="trailer"
                   value="trailer"> Trailer
            <span />
          </label>
          <label class="kt-radio">
            <input v-model="episode_details.type" type="radio"
                   name="bonus"
                   value="bonus"> Bonus
            <span />
          </label>
        </div>
      </div>

      <div class="form-group kt-form__group">
        <label for="episode_detail_radio_player_category">Radio Player Category</label>
        <input v-model="episode_details.rp_category_id" type="hidden">
        <multiselect id="episode_detail_radio_player_category"
                     v-model="selected_radio_player_category"
                     name="Radio Player Category"
                     data-vv-scope="details-form"
                     :allow-empty="false"
                     :options="radio_player_categories"
                     track-by="id" :searchable="true"
                     :show-labels="true" label="name"
                     placeholder="Pick a Category" />
        <span v-show="errors.has('Radio Player Category', 'details-form')" class="text-ss-danger"><br>{{ errors.first('Radio Player Category', 'details-form') }}</span>
      </div>

      <div class="form-group kt-form__group">
        <label for="episode_detail_season">Season No.</label>
        <input id="episode_detail_season"
               v-model="episode_details.season_number"
               v-validate="'integer'" name="Season Number"
               type="number"
               data-vv-scope="details-form"
               class="form-control kt-input">
        <span class="kt-form__help">If you wish your podcast to be broken down into seasons & episodes this must be populated</span>
        <span v-show="errors.has('Season Number', 'details-form')" class="text-ss-danger"><br>{{ errors.first('Season Number', 'details-form') }}</span>
      </div>

      <div class="form-group kt-form__group">
        <label for="episode_detail_episode">Episode No.</label>
        <input id="episode_detail_episode"
               v-model="episode_details.episode_number"
               v-validate="'integer'" name="Episode Number"
               type="number"
               data-vv-scope="details-form"
               class="form-control kt-input">
        <span class="kt-form__help">If you wish your podcast to be broken down into seasons & episodes this must be populated</span>
        <span v-show="errors.has('Episode Number', 'details-form')" class="text-ss-danger"><br>{{ errors.first('Episode Number', 'details-form') }}</span>
      </div>

      <div class="form-group kt-form__group">
        <label for="episode_detail_link">Link</label>
        <input id="episode_detail_link"
               v-model="episode_details.link"
               v-validate="{url: {require_protocol: true }}" name="Episode Link"
               type="text"
               data-vv-scope="details-form"
               class="form-control kt-input">
        <span class="kt-form__help">e.g. https://my-podcast.fm</span>
        <span v-show="errors.has('Episode Link', 'details-form')" class="text-ss-danger"><br>{{ errors.first('Episode Link', 'details-form') }}</span>
      </div>

      <div class="form-group kt-form__group">
        <label for="episode_detail_author">Author / Presenter</label>
        <input id="episode_detail_author"
               v-model="episode_details.author"
               v-validate="'required'"
               name="Episode Author"
               data-vv-scope="details-form" type="text"
               class="form-control kt-input">
        <span v-show="errors.has('Episode Author', 'details-form')" class="text-ss-danger"><br>{{ errors.first('Episode Author', 'details-form') }}</span>
      </div>

      <div class="form-group kt-form__group">
        <label for="explicit">Explicit</label>
        <select id="explicit" v-model="episode_details.explicit"
                class="form-control kt-input"
                name="Episode Explicitly" :v-validate="'required'"
                data-vv-scope="details-form">
          <option v-for="(option, index) in explicit_options" :key="index" :value="option.value">
            {{ option.label }}
          </option>
        </select>
        <span class="kt-form__help">Does this episode contain explicit content?</span>
        <span v-show="errors.has('Episode Explicitly', 'details-form')" class="text-ss-danger"><br>{{ errors.first('Episode Explicitly', 'details-form') }}</span>
      </div>
      <button class="w-100 btn item-save-btn btn-ss mt-ladda-btn ladda-button" data-style="expand-right" @click.prevent="validateAndSave()">
        <span>
          <i class="la la-save" />
          <span v-if="item.episode_detail && item.episode_detail.guid">Save Changes</span>
          <span v-else>Save</span>
        </span>
      </button>
    </div>
    <div class="col-12 col-md-6">
      <div class="form-group kt-form__group">
        <label for="episode_detail_guid">GUID</label>
        <input id="episode_detail_guid" v-model="episode_details.guid"
               disabled="disabled" type="text"
               class="form-control kt-input">
        <span v-if="!episode_details.guid" class="kt-form__help">This will be generated for you.</span>
      </div>

      <div class="form-group kt-form__group">
        <label for="duration">Duration</label>
        <input id="duration" v-model="episode_details.duration_f"
               disabled="disabled" type="text"
               class="form-control kt-input">
        <span v-if="!episode_details.duration_f" class="kt-form__help">This will be calculated for you.</span>
      </div>
    </div>
  </div>
</template>

<script>

import {
  convertToHhmmss,
} from 'Helpers/formatters';

export default {
  components: {},
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      episode_details: {},
      explicit_options: [
        { value: 'yes', label: 'Explicit' },
        { value: 'clean', label: 'Clean' },
      ],
      radio_player_categories: [],
      selected_radio_player_category: {},
    };
  },
  mounted() {
    if (this.item.episode_detail) {
      this.episode_details = this.item.episode_detail;
      this.episode_details.duration_f = convertToHhmmss(this.episode_details.duration);
    } else {
      this.episode_details.type = 'full';
    }
    this.getRadioPlayerCategories();
  },
  methods: {
    getRadioPlayerCategories() {
      axios.get("/api/v1/radioplayer/categories").then((response) => {
        this.radio_player_categories = response.data.data;
        if (this.item.episode_detail && this.item.episode_detail.rp_category_id) {
          // Once the radio player categories are loaded select the correct one if we are editing an item
          this.selected_radio_player_category = _.find(this.radio_player_categories, rp_category => rp_category.id === this.item.episode_detail.rp_category_id);
        }
      }).catch((error) => {
        window.handleAxiosError(error);
      });
    },
    validateAndSave() {
      this.$validator.validateAll('details-form').then((result) => {
        if (result) {
          this.save();
        } else {
          toastr.error("some fields have not been populated correctly.");
        }
      });
    },
    save() {
      const data = {
        rp_category_id: this.selected_radio_player_category.id,
        link: this.episode_details.link,
        author: this.episode_details.author,
        explicit: this.episode_details.explicit,
        episode_number: this.episode_details.episode_number,
        season_number: this.episode_details.season_number,
        type: this.episode_details.type,
      };

      axios.post(`/api/v1/items/${this.item.uuid}/episode-detail`, data).then((response) => {
        toastr.success("Saved Episode Detail");
        EventBus.$emit('item-updated', response.data.data);
      }).catch((error) => {
        window.handleAxiosError(error);
      });
    },
  },
};
</script>
